<template>
  <section class="page-banner" :class="themeClass" :style="bannerStyle">
    <div class="container">
      <div v-reveal class="banner-copy">
        <p>{{ $pick(eyebrow) }}</p>
        <h1>{{ $pick(title) }}</h1>
        <span>{{ $pick(subtitle) }}</span>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "PageBanner",
  props: {
    eyebrow: [String, Object],
    title: [String, Object],
    subtitle: [String, Object],
    backgroundImage: {
      type: String,
      default: ""
    },
    themeClass: {
      type: String,
      default: ""
    }
  },
  computed: {
    bannerStyle() {
      if (!this.backgroundImage) {
        return {};
      }

      return {
        backgroundImage: `linear-gradient(90deg, rgba(1, 28, 58, 0.92), rgba(2, 56, 113, 0.72) 45%, rgba(2, 56, 113, 0.42)), url('${this.backgroundImage}')`,
        backgroundPosition: "center center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat"
      };
    }
  }
};
</script>

<style scoped>
.page-banner {
  display: flex;
  align-items: center;
  min-height: 320px;
  padding-top: 130px;
  color: #fff;
  background:
    linear-gradient(90deg, rgba(1, 28, 58, 0.86), rgba(2, 56, 113, 0.56)),
    linear-gradient(135deg, #0a2b54, #275f9a 50%, #7aa0cf);
}

.banner-copy {
  padding: 50px 0;
}

.banner-copy p {
  margin: 0 0 10px;
  font-size: 14px;
  letter-spacing: 0.22em;
  text-transform: uppercase;
}

.banner-copy h1 {
  margin: 0 0 12px;
  font-size: clamp(34px, 5vw, 52px);
}

.banner-copy span {
  display: block;
  max-width: 58em;
  line-height: 1.7;
  font-size: 16px;
  opacity: 0.88;
}

@media (max-width: 760px) {
  .page-banner {
    min-height: 240px;
    padding-top: 72px;
  }

  .banner-copy {
    padding: 42px 0 36px;
  }

  .banner-copy p {
    font-size: 12px;
    letter-spacing: 0.16em;
  }

  .banner-copy h1 {
    font-size: 30px;
    line-height: 1.2;
  }

  .banner-copy span {
    font-size: 14px;
  }
}
</style>
